import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import {BatchCard} from '../../../../../helpers/elements/card/batch-card/BatchCard'
import {BatchError} from '../../../../../interfaces/batch'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {useGetErrorBatchesQuery} from '../../../../../redux/api/services/batch'
import {KTSVG} from '../../../../../template/_metronic/helpers'
import {ListLoading} from '../../../../../helpers/elements/table/loading/ListLoading'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export function ErrorBatchesList() {
  const [page, setPage] = useState(1)
  const [timeStamp, setTimeStamp] = useState('')
  const infoState = useSelector((state: RootState) => state.info)

  const {data, isFetching, isError, error, refetch} = useGetErrorBatchesQuery({
    info: infoState,
    requestContent: {page: page, pageSize: 10},
  })
  useEffect(() => {
    if (timeStamp === '' && page !== 1) return
    refetch()
  }, [timeStamp])

  return (
    <>
      <TitleCard title='Pagos fallidos' subtitle='Listado de pagos fallidos'>
        <button
          className='btn btn-primary'
          onClick={() => {
            setPage(1)
            setTimeStamp(new Date().getTime().toString())
          }}
        >
          Refrescar
        </button>
      </TitleCard>
      {/* TODO: Usar un empty state cuando no exista data */}
      {isError ? (
        <div className='card h-150px'>
          <div className='card-body'>
            <CustomErrorAlert error={error} show={isError} />
          </div>
        </div>
      ) : (
        <>
          {isFetching && <ListLoading />}
          {data?.responseContent && data?.responseContent.length > 0 ? (
            <InfiniteScroll
              dataLength={data?.responseContent.length || 0}
              next={() => setPage((prevPage) => prevPage + 1)}
              hasMore={(data?.responseContent.length || 0) >= page * 10}
              loader={<h4>Cargando...</h4>}
              endMessage={
                <p style={{textAlign: 'center'}}>
                  <b>¡Llegó al final de la lista!</b>
                </p>
              }
            >
              {data?.responseContent.map((item: BatchError) => (
                <BatchCard
                  key={item.id}
                  title={item.title}
                  subtitle={'Ref: ' + item.reference}
                  errorMessage={item.errorMessage}
                  icon={true}
                  columns={[
                    {
                      title: 'Pagos a realizar',
                      className: '',
                      value: (
                        <>
                          <span className='text-success'>{item.validRecords}</span>
                          <span className='text-gray'> / {item.totalRecords}</span>
                        </>
                      ),
                    },
                    {
                      title: 'Fecha de creación',
                      className: '',
                      value: <span className='text-primary-dark'>{item.creationDate}</span>,
                    },
                    {
                      title: 'Fecha a ejecutar',
                      className: '',
                      value: <span className='text-primary-dark'>{item.scheduledDate}</span>,
                    },
                    {
                      title: 'Monto a pagar',
                      className: 'text-xxl-end',
                      value: <span className='text-primary-dark'>{item.paidAmount}</span>,
                    },
                    {
                      title: 'Acciones',
                      className: 'flex-nowrap text-end',
                      value: (
                        <>
                          <Link
                            className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary'
                            to={`/errors/${item.id}/detail`}
                          >
                            <KTSVG path='/media/soyfri-media/arrow-right-short.svg' />
                          </Link>
                        </>
                      ),
                    },
                  ]}
                />
              ))}
            </InfiniteScroll>
          ) : (
            <div className='text-center'>
              <div className='d-flex flex-column py-5'>
                <span className='fw-semibold text-primary-dark fs-2qx'>
                  ¡No tienes pagos con error actualmente!
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}
